import React from 'react';

function RecoverArrowIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.638 13.026C5.57038 13.1403 5.52667 13.267 5.50952 13.3987C5.49237 13.5303 5.50214 13.664 5.53823 13.7918C5.57433 13.9195 5.636 14.0386 5.7195 14.1418C5.803 14.2449 5.9066 14.3301 6.024 14.392C6.26326 14.5242 6.54413 14.5593 6.80858 14.4903C7.07303 14.4212 7.30086 14.2533 7.445 14.021C8.551 12.167 10.604 11 12.87 11C15.307 11 17.489 12.351 18.518 14.429C18.764 14.927 19.386 15.139 19.906 14.902C20.425 14.664 20.646 14.069 20.399 13.569C19.028 10.802 16.118 9.00004 12.87 9.00004C9.85 9.00004 7.111 10.557 5.638 13.026Z"
                fill="white"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5 10V13.9C5 14.507 5.494 15 6.102 15H9.998C10.2632 15 10.5176 14.8947 10.7051 14.7071C10.8926 14.5196 10.998 14.2653 10.998 14C10.998 13.7348 10.8926 13.4805 10.7051 13.2929C10.5176 13.1054 10.2632 13 9.998 13H7.003V10C7.003 9.73442 6.89748 9.47969 6.70967 9.29187C6.52185 9.10405 6.26711 8.99854 6.0015 8.99854C5.73589 8.99854 5.48115 9.10405 5.29333 9.29187C5.10551 9.47969 5 9.73442 5 10Z"
                fill="white"
            />
        </svg>
    );
}

export default RecoverArrowIcon;
